// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee91a75e","678":"16466405","757":"89175cc3"}[chunkId] + ".chunk.js";
};